import store from '@/store'
import network from '@/utils/network'
import { agencyPath, createRequestWithComputedFilters } from '@/utils/api'

/**
 * Créé / met à jour une demande
 * @returns {Promise<>}
 */
export const postAgencyAgentRequest = async ({ agent, status, ...agentRequest }) => {
  const slugAgency = store.getters['user/agencySlug']
  const slugAgent = _.isObject(agent) ? agent.slug : agent
  const r = await network.post(`agency/${slugAgency}/agent/${slugAgent}/request${status ? `/${status}` : ''}`, agentRequest)
  return r.data
}

/**
 * Récupère la liste des demandes d'une agence
 * @returns {Promise<>}
 */
export const fetchAgencyRequests = createRequestWithComputedFilters(
  async (params) => {
    const slugAgency = store.getters['user/agencySlug']
    const r = await network.post(`/agency/${slugAgency}/fetch/agent-requests`, params)
    return r.data
  },
  {
    orderBy: 'createdAt',
    filters: {
      status: [],
      requestTypes: []
    }
  }
)

/**
 * Supression d'une demande
 * @param agentRequest
 * @return {Promise<>}
 */
export const deleteAgentRequest = async (agentRequest) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.delete(`agency/${slugAgency}/request/${agentRequest.id}`)
  return r.data
}

/**
 * Récupère les comptes des AgentRequest non lues
 * @returns {Promise<any>}
 */
export const getAgencyAgentRequestUnread = async () => {
  const r = await network.get(`${agencyPath()}/requests/unread`)
  return r.data
}
